import getMappedHTML from './mapped-html';
import getScrollPosition from './scroll-position';
import getScrollStatus from './scroll-status';
import getSelectedElement from './selected-element';
import getFocusedElement from './focused-element';
import getHoveredElement from './hovered-element';
import getLoadedStatus from './loaded-status';
import getDisabledStatus from './disabled-status';
import getUpdatedAt from './updated-at';
import getSelection from './selection';
import getDeviceMode from './device-mode';

export default {
  getMappedHTML,
  getScrollPosition,
  getScrollStatus,
  getHoveredElement,
  getSelectedElement,
  getFocusedElement,
  getLoadedStatus,
  getDisabledStatus,
  getUpdatedAt,
  getSelection,
  getDeviceMode,
};
